var lib_core = require("lib-core");


var SwitcherStateMachine = function (root, model) {
    var self = this;

    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(this);

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.SWITCHER_CLICK;
        },

        function(cEvent){
            self.model.selectedItem(cEvent.element());
        }
    );

    //SWITCHER_DELETE TRANSITION
    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.SWITCHER_DELETE || cEvent.isKeyPressed( 'delete', 'backspace');
        },

        function(cEvent){
            self.root.rec();
            self.model.deleteSelection();
            self.root.stopRec();
        }
    );
};

lib_core.inherit(SwitcherStateMachine, lib_core.StateMachine);

module.exports = SwitcherStateMachine;